
import AuthorizationRoutes from "@/modules/authorization";
import BetsRoutes from "@/modules/bets";
import BonusRoutes from "@/modules/bonus";
import FavouritesRoutes from "@/modules/favourites";
import RaceRoutes from "@/modules/race";
import SportsRoutes from "@/modules/sports";
import VirtualSportRoutes from "@/modules/virtual-sport";
import MyMarketRoutes from "@/modules/my-market";
import NotificationsRoutes from "@/modules/notification";
import ReferEarnRoutes from "@/modules/refer-earn";
import GamesRoutes from "@/modules/games";
import MatkaRoutes from "@/modules/matka";
import WalletRoutes from "@/modules/wallet";
import ChatRoutes from "@/modules/chats";
import SpinRoutes from "@/modules/SpinWheel";
import { createRouter, createWebHistory } from "vue-router";
import CricketFightRoutes from '@/modules/cricket-fight';
import AffiliateRoutes from '@/modules/affiliate';
import {routerGuard} from "./routerGuard";
import TwoFARoutes from '@/modules/2FA';

const Home = () => import("../views/Home.vue");
const PageNotFound = () => import("@/shared/components/no-data/PageNotFound.vue");
const MaintenanceComponent = () => import("@/shared/components/maintenance/Maintenance.vue");

const routes = [
  {
    path: "/home",
    name: "Home",
    component: Home,
    props: { key: "home" }
  },
  {
    path: "/poolzone",
    name: "Poolzone",
    component: Home,
    props: { key: "poolzone" }
  },
  FavouritesRoutes,
  BonusRoutes,
  SportsRoutes,
  RaceRoutes,
  VirtualSportRoutes,
  MyMarketRoutes,
  NotificationsRoutes,
  ReferEarnRoutes,
  BetsRoutes,
  GamesRoutes,
  MatkaRoutes,
  AuthorizationRoutes,
  WalletRoutes,
  ChatRoutes,
  CricketFightRoutes,
  AffiliateRoutes,
  SpinRoutes,
  TwoFARoutes,
  {
    path: "/maintenance",
    name: "Maintenance",
    component: MaintenanceComponent
  },
  
  {
    path: "/:pathMatch(.*)*",
    name: "PageNotFound",
    component: PageNotFound
  }
];


const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(routerGuard);

export default router;